// extracted by mini-css-extract-plugin
export default {"container":"TableScale_container__GAVFa","box":"TableScale_box__a1W1b"};